import Image from '../Image/Image'

export default function Blockquote (props = {
    text: null,
    caption: null,
    className: null,
    img: null
}) {
    if (!props.text && !props.children)
        return null

    const text = props.children || props.text

    const className = `blockquote ${props.className || ''}`
        .trim()

    const isImg = props.img && props.img.src

    return (
        <div className={className}>
            <div className="row">
                {isImg
                    && (
                        <div className="col-auto pad-0-r pad-4-r-lg-up pad-3-t-lg-down">
                            <div className="blockquote-avatar avatar">
                                <Image
                                    data-object-fit="cover"
                                    {...props.img}
                                />
                            </div>
                        </div>)}
                <figure
                    className={`col${isImg
                        ? ' pad-0-l-md-down'
                        : ''}`}
                >
                    <blockquote>
                        <p>{text}</p>
                    </blockquote>
                    {props.caption
                        && <figcaption>{props.caption}</figcaption>}
                </figure>
            </div>
        </div>
    )
}
